(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["debloat-clinical-results"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.dc-results').forEach(function (root) {
      const tabs = root.querySelectorAll('.dc-results__tab');
      const charts = root.querySelector('.dc-results__charts');
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          tabs.forEach(function (t) {
            t.setAttribute('aria-selected', 'false');
            t.setAttribute('tabindex', '-1');
          });
          tab.setAttribute('aria-selected', 'true');
          tab.removeAttribute('tabindex');
          if (charts) charts.setAttribute('data-active-period', tab.dataset.period);
        });
        tab.addEventListener('keydown', function (e) {
          if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
          e.preventDefault();
          const list = Array.from(tabs);
          const idx = list.indexOf(tab);
          const next = e.key === 'ArrowRight' ? (idx + 1) % list.length : (idx - 1 + list.length) % list.length;
          list[next].focus();
          list[next].click();
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["debloat-what-to-expect"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.dc-expect').forEach(function (root) {
      const timeline = root.querySelector('.dc-expect__timeline');
      const milestones = root.querySelectorAll('.dc-milestone');
      if (!timeline || !milestones.length) return;
      const ACTIVATION = 0.62;
      let raf;
      function update() {
        const vh = window.innerHeight || document.documentElement.clientHeight;
        const trigger = vh * ACTIVATION;
        const dotPositions = [];
        milestones.forEach(function (m) {
          const r = m.getBoundingClientRect();
          const dotY = r.top + 12 + 5.5;
          dotPositions.push(dotY);
          if (dotY <= trigger) m.classList.add('is-active');
          else m.classList.remove('is-active');
        });
        const first = dotPositions[0];
        const last = dotPositions[dotPositions.length - 1];
        let p = 0;
        if (last > first) {
          p = (trigger - first) / (last - first);
        } else {
          p = trigger >= first ? 1 : 0;
        }
        p = Math.max(0, Math.min(1, p));
        timeline.style.setProperty('--dc-progress', p.toFixed(3));
      }
      const onScroll = function () {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(update);
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
      update();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
